import { apiClient } from './api';
import type { Agent, CreateAgentRequest, UpdateAgentRequest } from '../types/agent';

export const agentService = {
  getAll: async (serverId?: string, tenantId?: string): Promise<Agent[]> => {
    const params: Record<string, string> = {};
    if (serverId) params.serverId = serverId;
    if (tenantId) params.tenantId = tenantId;
    const response = await apiClient.get<Agent[]>('/agents', { params });
    return response.data;
  },

  getById: async (id: string): Promise<Agent> => {
    const response = await apiClient.get<Agent>(`/agents/${id}`);
    return response.data;
  },

  create: async (data: CreateAgentRequest): Promise<string> => {
    const response = await apiClient.post<string>('/agents', data);
    return response.data;
  },

  update: async (data: UpdateAgentRequest): Promise<void> => {
    await apiClient.put(`/agents/${data.id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/agents/${id}`);
  },
};












